import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FryCommonModule } from '@fry/components/common';
import { MaterialModule } from '@fry/components/material';
import { RolesRoutingModule } from '@fry/components/roles/roles-routing.module';
import { RolesComponent } from '@fry/components/roles/roles/roles.component';
import { RoleListComponent } from '@fry/components/roles/role-list/role-list.component';
import { RoleAddComponent } from '@fry/components/roles/role-add/role-add.component';
import { RoleEditComponent } from '@fry/components/roles/role-edit/role-edit.component';
import { RoleDuplicateComponent } from '@fry/components/roles/role-duplicate/role-duplicate.component';

import { UnboxedModule } from '@fry/ui';
import { TranslationEditorModule } from '@fry/booking/translation-editor';

import { RolesSearch } from './roles.search';
import { RoleSlotComponent } from './role-slot/role-slot.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    RolesRoutingModule,
    MaterialModule,
    UnboxedModule,
    TranslationEditorModule,
  ],
  declarations: [
    RolesComponent,
    RoleListComponent,
    RoleAddComponent,
    RoleEditComponent,
    RoleDuplicateComponent,
    RoleSlotComponent
  ],
  providers: [
    RolesSearch
  ]
})
export class RolesModule {}
